<template>
    <div>
        <slot></slot>
        <slot name="activator"></slot>
    </div>
</template>

<script>
//      i use this for filler for component conditionals
//      for example:
//      <component
//          :is="hasMenu ? 'VMenu' : 'DummyActivator'"  <==
//      >
export default {
    name: "DummyActivator",
    setup() {
        return {};
    }
};
</script>
